/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React, { useContext, useEffect, memo, useState } from 'react'
import PageLoader from 'Lib/Pageloader'
import SupportArrow from 'SVGPath/down-chevron.svg'
import { AccountsContext } from 'AccountsContext'
import { TripState } from 'AccountsContainers/Trips/context'
import { CONTACT_US, WELL_HELP } from 'AccountsConstants/language/trips'
// import Login from '../../Login'
import { getCommonClevertapParams, triggerClevertap, readCookie } from 'AccountsUtils'
import SupportWidget from '../../../components/Support/SupportWidget'
import TripListBox from './TripListBox'
import EmailVerification from '../../../components/Desktop/EmailVerification'
import CancellationBlockModal from '../../../newComponents/CancellationBlockModal'
import { CANCELLATION_TEMPORARILY_DISABLED } from '../../../constants/app'
import './tripListDesktop.css'
import { checkUserLogin } from '../../../utils/index'
import { getAuthenticated } from '../../../pages/Trips/trips.helper'
import { getMappedValue } from '../../../utils/arabicUtils'
import { isInFlyinDomain } from 'AccountsUtils'

const TripListDesktop = ({ props }) => {
  const {
    isLoggedIn,
    checkSignIn,
    accountsLoading,
    openModal,
    isVerified,
    showWidget,
    checkVerification
  } = useContext(AccountsContext)

  const [showSupportModal, setShowSupportModal] = useState(false)

  useEffect(() => {
    if (!isLoggedIn) {
      checkSignIn()
    }
    checkVerification()
    const CommonClevertapParams = getCommonClevertapParams()
    let emailFromCookie = decodeURIComponent(readCookie('userid'))
    emailFromCookie = emailFromCookie.split('|')
    emailFromCookie =
      emailFromCookie && emailFromCookie.length && emailFromCookie !== 'null' ?
        emailFromCookie[0] :
        ''
    triggerClevertap('Account', {
      page_name: 'trip_section_loaded',
      domain: CommonClevertapParams.domain,
      source_page: CommonClevertapParams.source_page,
      platform: CommonClevertapParams.platform,
      logged_id: isLoggedIn,
      email_id: emailFromCookie
    })
  }, [])
  const showSupportWidget = () => {
    const CommonClevertapParams = getCommonClevertapParams()
    // if (selectedTrip.internalUserForSupport) {
    //   triggerClevertap('Account_UI_Action', {
    //     action_name: 'contact_us_clicked',
    //     domainName: CommonClevertapParams.domain,
    //     source_page: CommonClevertapParams.source_page,
    //     platform: CommonClevertapParams.platform,
    //     logged_id: isLoggedIn
    //   })
    // } else {
    triggerClevertap('Account_UI_Action', {
      action_name: 'contact_us_clicked',
      domainName: CommonClevertapParams.domain,
      source_page: CommonClevertapParams.source_page,
      platform: CommonClevertapParams.platform,
      logged_id: isLoggedIn
    })
    // }
    if (CANCELLATION_TEMPORARILY_DISABLED) {
      setShowSupportModal(true)
    } else {
      openModal()
    }
  }
  const deleteCookie = name => {
    document.cookie =
      `${name
      }=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=qa2.cleartrip.ae`
    document.cookie =
      `${name
      }=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=.cleartrip.ae`
    document.cookie =
      `${name
      }=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=cleartrip.ae`
    document.cookie =
      `${name
      }=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=qa2.cleartrip.ae`
  }

  useEffect(() => {
    if (checkUserLogin()) {
      const getAuthenticatedApiResponse = async () => {
        const resp = await getAuthenticated()
        const { status, error } = resp
        if (error?.response?.status === 401 && status !== 200) {
          deleteCookie('userid')
          window.localStorage.removeItem('ON_LOGIN_PUSH')
          window.location.href = '/signout'
        }
      }
      getAuthenticatedApiResponse()
    }
  }, [])
  const ContactUs = () => {
    if (isInFlyinDomain()) {
      return null
    }

    return (
      <>
        <div className="p-4" onClick={showSupportWidget}>
          <div className="flex flex-1 p-2 mb-4 button flex-middle">
            <div className="flex-1">
              <div className="fs-15 fw-600 us-text">
                {getMappedValue('contact us')}
              </div>
              <div className="fs-12 mt-1 c-grey-40 us-text">
                {getMappedValue("we'll help you out")}
              </div>
            </div>
            <div className="p-2">
              <SupportArrow className="right-arrow" />
            </div>
          </div>
        </div>
        <CancellationBlockModal
          isOpen={showSupportModal}
          onClose={() => setShowSupportModal(false)}
          isPWA={false}
          variant="general"
        />
        <SupportWidget />
      </>
    )
  }

  let listPage
  // if (!isLoggedIn) {
  //   listPage = (
  //     <>
  //       <Login />
  //       <aside className="rightCol colZero w-20p">
  //         <section className="guestFeatures">
  //           <div className="benefitTitle fs-14 fw-400">
  //             <h2 className="fw-600 fs-14">Cleartrip Account benefits</h2>
  //           </div>
  //           <div className="feature cancellations">
  //             <p className="fs-14 pb-2 fw-400">Online Cancellations</p>
  //             <p className="weak">Cancel or re-schedule your trips effortlessly in a few easy steps</p>
  //           </div>
  //           <div className="feature trips">
  //             <p className="fs-14 pb-2 fw-400">Review &amp; share trip information</p>
  //             <p className="weak">Print invoices &amp; tickets. Email or SMS booking details to fellow travellers</p>
  //           </div>
  //           <div className="feature expressway">
  //             <p className="fs-14 pb-2 fw-400">Expressway</p>
  //             <p className="weak">Store your cards for 1-click bookings. It's safe &amp; blazing fast</p>
  //           </div>
  //           <div className="feature travellers">
  //             <p className="fs-14 pb-2 fw-400">Save travellers</p>
  //             <p className="weak">Save travellers that you often book for, so you never have to type it again</p>
  //           </div>
  //         </section>
  //       </aside>
  //     </>
  //   )
  if (accountsLoading) {
    listPage = (
      <PageLoader
        title="Fetching your trip"
        message="Please wait while we fetch your trips"
      />
    )
    // eslint-disable-next-line no-constant-condition
  } else if ((!accountsLoading && isLoggedIn) || true) {
    listPage = (
      <React.Fragment>
        <div className="w-60p results-container" style ={{overflow: 'scroll'}}>
          <TripState>
            <TripListBox />
          </TripState>
        </div>
        <div className={isInFlyinDomain() ? '' : 'w-25p'}>
          <If condition={showWidget}>
            <EmailVerification isVerified={isVerified} />
          </If>
          <ContactUs />
        </div>
      </React.Fragment>
    )
  }

  return <React.Fragment>{listPage}</React.Fragment>
}

export default memo(TripListDesktop)
